const loggedStatus = (state) => state.is_logged

export default {
  loggedStatus
}
